import {
  AUTO,
  BICYCLE,
  FREIGHT,
  PEDESTRIAN,
  TRANSIT
} from '../constants/modalTiers'
import { NO, YES } from '../constants/roadwayVariables'

import { LAND_USE_CONTEXT } from './segments.config'

export const roadwayVariables = [
  {
    title: 'What is your project called?',
    field: 'roadway_name',
    placeholder: 'Project Name',
    id: 'roadway_name',
    inputType: 'string',
    required: true,
    inputProps: {},
    step: 0,
    notes: 'Indicate if project is planned, or existing'
  },
  {
    title: 'What is the right-of-way width of your street (in feet)?',
    field: 'street_width',
    placeholder: 'Enter Street Width',
    id: 'street_width',
    inputType: 'number',
    inputProps: { min: 0, max: 200 },
    required: true,
    step: 0
  },
  {
    title: 'Is there a raised median?',
    field: 'raised_median',
    placeholder: 'Enter Value',
    id: 'raised_median',
    inputType: 'dropDown',
    required: true,
    step: 0,
    notes:
      'Could have a fence or ditch in between, not necessarily always a raised median',
    values: [YES, NO]
  },

  {
    title: 'Is there high-capacity transit?',
    field: 'high_capacity_transit',
    placeholder: 'Enter Value',
    id: 'high_capacity_transit',
    inputType: 'dropDown',
    step: 0,
    required: true,
    notes:
      'Consult local and regional plans to determine if the corridor is intended to serve high capacity transit. See User Guide for additional details about high capacity transit. Select "Yes" if queue jump, curbside, or center running transit lanes are present, or if the corridor will serve high capacity transit without dedicated lanes.',
    values: [YES, NO]
  },
  {
    title: 'How many travel lanes are there?',
    field: 'travel_lanes',
    placeholder: 'Enter Value',
    id: 'travel_lanes',
    inputType: 'slider',
    sliderValueFormat: '',
    required: true,
    step: 1,
    max: 10,
    min: 1,
    inputProps: { min: 0, max: 100 },
    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    notes: 'Total for both directions, not including center turn lane'
  },

  {
    title: 'What is the speed limit?',
    field: 'prevailing_posted_speed',
    placeholder: 'Enter Value',
    id: 'prevailing_posted_speed',
    inputType: 'slider',
    sliderValueFormat: 'speed',
    required: true,
    max: 65,
    min: 10,
    step: 5,
    notes: 'If known, use prevailing speed',
    values: [10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65]
  },

  {
    title: 'How much daily traffic is there?',
    field: 'avg_daily_traffic',
    placeholder: 'Enter Value',
    id: 'avg_daily_traffic',
    inputType: 'dropDown',
    sliderValueFormat: 'traffic',
    required: true,
    step: 5,
    min: 0,
    max: 45,
    notes: 'Total for both directions / SEMCOG Traffic Volume Map',
    notesLink: 'https://maps.semcog.org/trafficvolume/',
    values: [
      '<5000',
      '5001-10000',
      '10001-20000',
      '20001-30000',
      '30001-40000',
      '40001-50000',
      '50001-60000',
      '60001-70000',
      '70001-80000',
      '>=80001'
    ]
  },
  {
    title: 'What is the land use context?',
    field: 'land_use_context',
    placeholder: 'Enter Value',
    id: 'land_use_context',
    inputType: 'dropDown',
    required: true,
    step: 2,
    notes: 'See User Guide for additional details on land use contexts',
    values: LAND_USE_CONTEXT
  }
]

export const modalTiers = [
  {
    name: PEDESTRIAN,
    id: 'pedestrian',
    color: '#FF00C5',
    notes: 'People Walking',
    notesLink:
      'https://gis.semcog.org/portal/apps/webappviewer/index.html?id=a4ace662f6ea4a538c53202ff19b847a'
  },
  {
    name: BICYCLE,
    id: 'bicycle',
    color: '#4DE600',
    notes: 'People Biking'
  },
  {
    name: TRANSIT,
    id: 'transit',
    color: '#A73801',
    notes: 'People Riding Transit'
  },
  {
    name: AUTO,
    id: 'auto',
    color: '#E69702',
    notes: 'People Driving'
  },
  {
    name: FREIGHT,
    id: 'freight',
    color: '#00A8E6',
    notes: 'People Moving Freight'
  }
]
